//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { createNamespacedHelpers } from 'vuex';

import { Apps, AuthProviders } from 'utils/constants';

import {
	NAME_EDIT,
	SIGNUP_FORM_VISIBLE,
	COMPANY_EDIT,
	EMAIL_EDIT,
	PASSWORD_EDIT,
	TERMS_EDIT,
	TIPS_EDIT,
	PIPEDRIVE_OAUTH_VISIBLE,
	HUBSPOT_OAUTH_VISIBLE,
	SIGNUP_PLAN_GROUP,
	SIGNUP_PLAN_EVENTS,
	SIGNUP_PLAN_ACTIVE_CONTACTS,
	RESET_STATE,
	INTEGRATION_TO_CONNECT
} from 'store/modules/register/mutationTypes';

import {
	REGISTER_USER_WITH_CREDENTIALS,
	START_OAUTH,
	GET_SIGNUP_PLAN,
	STORE_SIGNUP_PLAN,
	STORE_SIGNUP_COUPON,
	GET_INTENT,
	TERMS_CONFIRMATION_SHOW,
	TERMS_CONFIRMATION_HIDE,
	NAVIGATE_CONNECTIONS,
	NAVIGATE_HOME
} from 'store/modules/register/actionTypes';
import ROUTE_NAMES from 'router/route-names';
import HubspotLogo from '../images/hubspot-logo.svg';
import PipedriveLogo from '../images/pipedrive-logo.svg';
import GoogleLogo from '../images/google-logo.svg';

const {
	mapState,
	mapMutations,
	mapActions
} = createNamespacedHelpers('register');
const userHelpers = createNamespacedHelpers('user');

export default {
	components: {
		HubspotLogo,
		PipedriveLogo,
		GoogleLogo
	},

	data: () => ({
		oauthProvider: null,
		loginRoute: ROUTE_NAMES.LOGIN
	}),

	computed: {
		...mapState([
			'isSignupFormVisible',
			'nameField',
			'companyField',
			'emailField',
			'passwordField',
			'termsCheckbox',
			'tipsCheckbox',
			'isOauthSignupButtonVisible',
			'isPipedriveOauthVisible',
			'isHubspotOauthVisible',
			'isTermsConfirmationDialogVisible',
			'generalErrors'
		]),

		...userHelpers.mapGetters([
			'isUserFetched'
		])
	},

	watch: {
		isUserFetched(newValue) {
			if (newValue) {
				this.NAVIGATE_HOME();
			}
		}
	},

	mounted() {
		if (this.isUserFetched) {
			this.NAVIGATE_HOME();
		}

		this.RESET_STATE();
		this.GET_SIGNUP_PLAN();

		const {
			plan,
			plangroup,
			events,
			activecontacts,
			coupon,
			oauth,
			connect
		} = this.$route.query;

		if (coupon) {
			this.STORE_SIGNUP_COUPON(coupon);
		}

		if (plan) {
			this.STORE_SIGNUP_PLAN(plan);
		}

		if (plangroup) {
			this.SIGNUP_PLAN_GROUP(plangroup);
		}

		if (events) {
			this.SIGNUP_PLAN_EVENTS(events);
		}

		if (activecontacts) {
			this.SIGNUP_PLAN_ACTIVE_CONTACTS(activecontacts);
		}

		if (oauth === AuthProviders.PIPEDRIVE) {
			this.SIGNUP_FORM_VISIBLE(false);
			this.HUBSPOT_OAUTH_VISIBLE(false);
		}

		if (oauth === AuthProviders.HUBSPOT) {
			this.SIGNUP_FORM_VISIBLE(false);
			this.PIPEDRIVE_OAUTH_VISIBLE(false);
		}

		if (connect === Apps.KLAVIYO) {
			this.INTEGRATION_TO_CONNECT(Apps.KLAVIYO);
		}

		this.GET_INTENT();
	},

	methods: {
		...mapMutations([
			SIGNUP_FORM_VISIBLE,
			NAME_EDIT,
			COMPANY_EDIT,
			EMAIL_EDIT,
			PASSWORD_EDIT,
			TERMS_EDIT,
			TIPS_EDIT,
			PIPEDRIVE_OAUTH_VISIBLE,
			HUBSPOT_OAUTH_VISIBLE,
			SIGNUP_PLAN_GROUP,
			SIGNUP_PLAN_EVENTS,
			SIGNUP_PLAN_ACTIVE_CONTACTS,
			RESET_STATE,
			INTEGRATION_TO_CONNECT
		]),

		...mapActions([
			REGISTER_USER_WITH_CREDENTIALS,
			START_OAUTH,
			GET_SIGNUP_PLAN,
			STORE_SIGNUP_PLAN,
			STORE_SIGNUP_COUPON,
			GET_INTENT,
			TERMS_CONFIRMATION_SHOW,
			TERMS_CONFIRMATION_HIDE,
			NAVIGATE_CONNECTIONS,
			NAVIGATE_HOME
		]),

		onStartGoogleOauth() {
			if (!this.termsCheckbox.value) {
				this.TERMS_CONFIRMATION_SHOW();
				this.oauthProvider = AuthProviders.GOOGLE;

				return;
			}

			this.START_OAUTH({ provider: AuthProviders.GOOGLE });
		},

		onStartPipedriveOauth() {
			if (!this.termsCheckbox.value) {
				this.TERMS_CONFIRMATION_SHOW();
				this.oauthProvider = AuthProviders.PIPEDRIVE;

				return;
			}

			this.START_OAUTH({ provider: AuthProviders.PIPEDRIVE });
		},

		onStartHubspotOauth() {
			if (!this.termsCheckbox.value) {
				this.TERMS_CONFIRMATION_SHOW();
				this.oauthProvider = AuthProviders.HUBSPOT;

				return;
			}

			this.START_OAUTH({ provider: AuthProviders.HUBSPOT });
		},

		onAgreeTerms() {
			this.TERMS_EDIT(true);
			this.TERMS_CONFIRMATION_HIDE();

			if (this.oauthProvider === AuthProviders.PIPEDRIVE) {
				this.START_OAUTH({ provider: AuthProviders.PIPEDRIVE });
			}

			if (this.oauthProvider === AuthProviders.HUBSPOT) {
				this.START_OAUTH({ provider: AuthProviders.HUBSPOT });
			}

			if (this.oauthProvider === AuthProviders.GOOGLE) {
				this.START_OAUTH({ provider: AuthProviders.GOOGLE });
			}
		},

		onDisagreeTerms() {
			this.TERMS_CONFIRMATION_HIDE();
		}
	}
};

